import { api, apiCall, apiActionDispatcher, signalRWrappedApiCall } from './api';
import * as types from './types';
import Moment from 'moment';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import { build as buildHelpers } from '../helpers';
import { buildsReducer } from '../reducers';
import { keys, uniq } from 'lodash';

const fetchBuildsDispatcher =
  apiActionDispatcher({ actionTypes: types.buildsActionTypes });
export const fetchBuilds = (days) => signalRWrappedApiCall(
  apiCall(
    fetchBuildsDispatcher,
    api.build.fetchRecent,
    state => {
      const builds = buildsReducer.buildsById(state);
      const buildIds = keys(builds) || [];
      if (buildIds.length === 0) {
        return false;
      }

      const earliestBuildId = buildIds[0];
      const earliestBuild = builds[earliestBuildId];

      const getDayDiff = (fetchDay) => {
        const earliestDay = Moment(earliestBuild.updated_at);
        const diff = fetchDay.diff(earliestDay, 'days');
        return diff;
      };

      const isWeekendDay = (checkDay) =>
        checkDay.day() === 0 ||
        checkDay.day() === 6;

      const today = Moment().startOf('day');
      const fetchDay = Moment(today).subtract(days, 'days');
      let diff = getDayDiff(fetchDay);

      // trying to do a smarter diff, compare diff against day considered and possibly
      // pull in range since if on a weekend day we may not have a build from that day
      // * it's possible a weekday may also not have a build, but is less likely
      // * and pulling in the range too much may yield false positives
      while (diff < 0 && isWeekendDay(fetchDay)) {
        fetchDay.add(1, 'day');
        diff = getDayDiff(fetchDay, earliestBuild);
      }

      return diff >= 0;
    },
    null,
    state => state.builds.request,
    null,
    [days]
  ),
  fetchBuildsDispatcher,
  signalRHubManager,
  subscriptionTypes.builds
);

export const fetchRCBuildsSinceLatestRelease = (product) => signalRWrappedApiCall(
  apiCall(
    fetchBuildsDispatcher,
    api.build.fetchRCSinceLatestRelease,
    state => {
      const buildsByType = buildsReducer.buildsByBuildTypes(state);
      const releaseBuilds = buildsByType[buildHelpers.LATEST_RELEASE];
      const rcBuilds = buildsByType[buildHelpers.BUILD_RC];
      if (releaseBuilds && rcBuilds &&
        releaseBuilds.length !== 0 && rcBuilds.length !== 0) {
        const productNamesInDB = buildHelpers.getProdNamesByProductName(product);
        const actualProducts = uniq(releaseBuilds.map(build => build.product));
        const diff = productNamesInDB.filter(p => !actualProducts.includes(p));
        if (diff.length !== 0) {
          return false;
        }
        const releaseBuildNumber = releaseBuilds[0].build;
        return rcBuilds[0].build >= releaseBuildNumber;
      }
      return false;
    },
    null,
    state => state.builds.request,
    null,
    [product]
  ),
  fetchBuildsDispatcher,
  signalRHubManager,
  subscriptionTypes.builds
);

export const fetchBuildsSince = (timestamp) => signalRWrappedApiCall(
  apiCall(
    fetchBuildsDispatcher,
    api.build.fetchSince,
    state => {
      const buildsByType = buildsReducer.buildsByBuildTypes(state);
      // loaded, if all of the buildTypes' earliest build is older than given timestamp
      // skips released build check as they would be included in production
      return buildHelpers.BUILD_TYPE_NAMES.slice(1).every(type => {
        const builds = buildsByType[type];
        const givenDay = Moment(timestamp, 'X');
        if (builds && builds.length > 0) {
          return givenDay.diff(Moment(builds[0].updated_at), 'days') < 0;
        }
        // not loaded, if any build type has no builds
        return false;
      });
    },
    null,
    null,
    [timestamp]
  ),
  fetchBuildsDispatcher,
  signalRHubManager,
  subscriptionTypes.builds
);

export const fetchBuildsSinceByType = (type, timestamp) => signalRWrappedApiCall(
  apiCall(
    fetchBuildsDispatcher,
    api.build.fetchSinceByType,
    state => {
      const buildsByType = buildsReducer.buildsByBuildTypes(state);
      const builds = buildsByType[type];
      const givenDay = Moment(timestamp, 'X');
      return builds && builds.length > 0 &&
        givenDay.diff(Moment(builds[0].updated_at), 'days') < 0;
    },
    null,
    null,
    [type, timestamp]
  ),
  fetchBuildsDispatcher,
  signalRHubManager,
  subscriptionTypes.builds
);


// WEBPACK FOOTER //
// src/actions/builds.js